import { render, staticRenderFns } from "./vendorForm.template.vue?vue&type=template&id=0c18a722&scoped=true&"
var script = {}
import style0 from "./vendorForm.template.vue?vue&type=style&index=0&id=0c18a722&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c18a722",
  null
  
)

export default component.exports